import React from "react";
import PropTypes from "prop-types";
import {controlPropTypes} from "../formhelpers";
import RecordGrid from "../BaseControls/RecordGrid/RecordGrid";

export default class MagicRootSummarySection extends React.Component {
    render() {
        const {descriptor} = this.props;
        return (
            <div className="form-item full-width">
                <div
                    id={descriptor.id}
                    className={`control-container-${descriptor.control} control-widget-${descriptor.key} magicrootsummarysection`}
                    data-widget-type={descriptor.control}
                    data-widget-label={descriptor.label}
                >
                    <RecordGrid {...this.props} />
                </div>
            </div>
        );
    }
}

MagicRootSummarySection.propTypes = {
    ...controlPropTypes(null, false),
    onCommitChange: PropTypes.func

};



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/Widget/magicrootsummarysection.js